import { createSelector } from "@reduxjs/toolkit";
import { selectHttpMcBimSpaceItems } from "./httpMcBimSelectors";

export const selectDuplicateSpaces = createSelector([selectHttpMcBimSpaceItems], (spaces) => {
  const byRoom = new Map<string, { roomNumber: string; count: number; fileNames: Set<string> }>();
  for (const space of spaces) {
    const entry = byRoom.get(space.name) ?? {
      roomNumber: space.name,
      count: 0,
      fileNames: new Set<string>(),
    };
    entry.count += 1;
    if (space.fileName) entry.fileNames.add(space.fileName);
    byRoom.set(space.name, entry);
  }
  return Array.from(byRoom.values())
    .filter((entry) => entry.count > 1)
    .map((entry) => ({ ...entry, fileNames: Array.from(entry.fileNames).sort() }))
    .sort((a, b) => a.roomNumber.localeCompare(b.roomNumber, "nb", { numeric: true }));
});
